(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["size-guide"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.__sgLoaded) return;
  window.__sgLoaded = true;

  /* Default BODY measurements in CM */
  var WOMEN = { columns: ['Height', 'Bust', 'Waist Size', 'Hip Size'], rows: [
    ['XXS', '155-160', '78-82', '58-62', '83-87'],
    ['XS', '160-165', '82-86', '62-66', '87-91'],
    ['S', '165-170', '86-90', '66-70', '91-95'],
    ['M', '165-170', '90-94', '70-74', '95-99'],
    ['L', '170-175', '94-100', '74-80', '99-105'],
    ['XL', '170-175', '100-106', '80-86', '105-111'],
    ['XXL', '175-180', '106-112', '86-92', '111-117'],
    ['3XL', '175-180', '112-118', '92-98', '117-123'],
    ['4XL', '175-180', '118-124', '98-104', '123-129'],
    ['5XL', '175-180', '124-130', '104-110', '129-135'],
    ['6XL', '175-180', '130-136', '110-116', '135-141']
  ]};
  var WOMEN_B = { columns: ['Height', 'Waist Size', 'Hip Size'], rows: WOMEN.rows.map(function (r) { return [r[0], r[1], r[3], r[4]]; }) };
  var MEN = { columns: ['Height', 'Chest', 'Waist Size'], rows: [
    ['XS', '160-165', '82-86', '66-71'],
    ['S', '165-170', '86-91', '71-76'],
    ['M', '170-175', '91-97', '76-81'],
    ['L', '175-180', '97-104', '81-89'],
    ['XL', '180-185', '104-112', '89-97'],
    ['XXL', '180-185', '112-120', '97-104'],
    ['3XL', '185-190', '120-128', '104-112'],
    ['4XL', '185-190', '128-136', '112-120'],
    ['5XL', '190-195', '136-144', '120-128'],
    ['6XL', '190-195', '144-152', '128-136']
  ]};
  var MEN_B = { columns: ['Height', 'Waist Size', 'Hip Size'], rows: [
    ['XS', '160-165', '66-71', '84-89'], ['S', '165-170', '71-76', '89-94'], ['M', '170-175', '76-81', '94-99'],
    ['L', '175-180', '81-89', '99-106'], ['XL', '180-185', '89-97', '106-113'], ['XXL', '180-185', '97-104', '113-120'],
    ['3XL', '185-190', '104-112', '120-127'], ['4XL', '185-190', '112-120', '127-134'], ['5XL', '190-195', '120-128', '134-141']
  ]};
  var BODY = { women: WOMEN, women_bottoms: WOMEN_B, men: MEN, men_bottoms: MEN_B };
  var STANDARD = ['XS', 'S', 'M', 'L', 'XL', 'XXL'];
  var ALIAS = { 'XXXL': '3XL', 'XXXXL': '4XL', '2XL': 'XXL', '2X': 'XXL', '3X': '3XL', '4X': '4XL', '1X': 'XL', '1XL': 'XL', '0XL': 'L' };
  var FIT = { skinny: 0, slim: 25, regular: 50, loose: 75, oversized: 100 };

  var DESC = {
    shoulder: 'Measure from where the shoulder seam meets the sleeve on one side to the other side.',
    bust: 'Measure straight across from the stitches below one armpit to the other.',
    chest: 'Measure straight across from the stitches below one armpit to the other.',
    waist: 'Measure straight across the narrowest part of the waist, from edge to edge.',
    hips: 'Measure straight across the widest part of the hips, from edge to edge.',
    length: 'Measure from where the shoulder seam meets the collar down to the hem.',
    'sleeve length': 'Measure from the shoulder seam down to the end of the cuff.',
    inseam: 'Measure from the crotch seam down to the bottom of the leg.',
    thigh: 'Measure straight across the leg just below the crotch.',
    'pants length': 'Measure from the top of the waistband down to the hem.'
  };
  var BODY_DESC = {
    bust: 'Measure the circumference over the fullest part of your bust.',
    chest: 'Measure the circumference over the fullest part of your chest, under the armpits.',
    waist: 'Measure your waist at the thinnest place.',
    hips: 'Measure the fullest part of your hips.'
  };

  var O = 'fill="none" stroke="#f08a24" stroke-width="2"';
  function badge(x, y, n) { return '<circle cx="' + x + '" cy="' + y + '" r="9" fill="#222"/><text x="' + x + '" y="' + (y + 4) + '" text-anchor="middle" font-size="11" font-weight="700" fill="#fff" font-family="Arial">' + n + '</text>'; }
  var FIG = {
    garment: { map: { shoulder: 1, bust: 2, chest: 2, waist: 3, hips: 4, length: 5, 'sleeve length': 6 }, svg:
      '<svg viewBox="0 0 220 250"><path d="M92 20 Q110 34 128 20 L152 26 L182 122 L167 127 L146 72 L144 110 L162 228 L58 228 L76 110 L74 72 L53 127 L38 122 L68 26 Z" fill="#fff" stroke="#333" stroke-width="1.4"/>' +
      '<path d="M70 27 H150" ' + O + '/><path d="M75 72 H145" ' + O + '/><path d="M77 106 H143" ' + O + '/><path d="M73 138 H147" ' + O + '/>' +
      '<path d="M24 20 V228" ' + O + '/><path d="M24 20 H92 M24 228 H58" stroke="#bbb" stroke-dasharray="2 3"/><path d="M158 22 L190 120" ' + O + '/>' +
      badge(62, 17, 1) + badge(110, 86, 2) + badge(155, 106, 3) + badge(155, 145, 4) + badge(12, 124, 5) + badge(198, 66, 6) + '</svg>' },
    pants: { map: { waist: 1, hips: 2, inseam: 3, length: 4, 'pants length': 4, thigh: 5 }, svg:
      '<svg viewBox="0 0 220 250"><path d="M66 20 H154 L164 228 H118 L110 96 L102 228 H56 Z" fill="#fff" stroke="#333" stroke-width="1.4"/><path d="M66 34 H154" stroke="#333"/>' +
      '<path d="M66 27 H154" ' + O + '/><path d="M61 62 H159" ' + O + '/><path d="M60 104 H106" ' + O + '/><path d="M113 104 L119 226" ' + O + '/><path d="M36 20 V228" ' + O + '/>' +
      badge(110, 14, 1) + badge(172, 62, 2) + badge(132, 170, 3) + badge(24, 124, 4) + badge(83, 118, 5) + '</svg>' },
    body: { map: { bust: 1, chest: 1, waist: 2, hips: 3 }, svg:
      '<svg viewBox="0 0 220 250"><circle cx="110" cy="26" r="15" fill="#f4f4f4" stroke="#333" stroke-width="1.4"/>' +
      '<path d="M101 41 H119 L122 52 L150 60 L158 132 L149 134 L141 84 L136 110 L146 150 L133 234 H117 L111 162 H109 L103 234 H87 L74 150 L84 110 L79 84 L71 134 L62 132 L70 60 L98 52 Z" fill="#eee" stroke="#333" stroke-width="1.4"/>' +
      '<ellipse cx="110" cy="82" rx="34" ry="5" ' + O + '/><ellipse cx="110" cy="110" rx="28" ry="5" ' + O + '/><ellipse cx="110" cy="142" rx="39" ry="6" ' + O + '/>' +
      badge(162, 82, 1) + badge(58, 110, 2) + badge(164, 146, 3) + '</svg>' }
  };

  function key(name) {
    var k = String(name).toLowerCase().replace(/\bsize\b/g, '').trim();
    if (k === 'hip') k = 'hips';
    if (k === 'sleeve') k = 'sleeve length';
    return k;
  }
  function raw(s) { return String(s).toUpperCase().replace(/\(.*?\)/g, '').replace(/\s+/g, '').trim(); }
  function norm(s) { var v = raw(s); return ALIAS[v] || v; }
  function fmt(n) { var r = Math.round(n * 10) / 10; return (r % 1 === 0) ? String(r) : r.toFixed(1); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function conv(val, from, to) {
    if (val === null || val === undefined || val === '') return '-';
    if (from === to) return esc(val);
    var f = from === 'cm' ? 1 / 2.54 : 2.54;
    return esc(String(val).replace(/\d+(\.\d+)?/g, function (m) { return fmt(parseFloat(m) * f); }));
  }
  function toRows(chart) {
    if (Array.isArray(chart.rows)) return chart.rows;
    return Object.keys(chart.rows || {}).map(function (s) { return [s].concat(chart.rows[s]); });
  }
  function pick(rows, sizes, fallbackStandard) {
    var out = [];
    sizes.forEach(function (s) {
      var n = norm(s), r = null;
      for (var i = 0; i < rows.length; i++) { if (norm(rows[i][0]) === n || raw(rows[i][0]) === raw(s)) { r = rows[i]; break; } }
      if (r) out.push([s].concat(r.slice(1)));
    });
    if (out.length) return out;
    return fallbackStandard ? rows.filter(function (r) { return STANDARD.indexOf(r[0]) > -1; }) : rows;
  }
  function getUnit() { try { return localStorage.getItem('sg-unit') || 'in'; } catch (e) { return 'in'; } }
  function setUnit(u) { try { localStorage.setItem('sg-unit', u); } catch (e) {} }

  function build(root) {
    var cfg; try { cfg = JSON.parse(root.querySelector('.sg-config').textContent); } catch (e) { cfg = {}; }
    var custom = cfg.custom || {};
    var srcUnit = String(custom.unit || 'cm').toLowerCase();
    var sizes = (cfg.sizes || []).filter(Boolean);
    var charts = {};
    if (custom.product && custom.product.columns) {
      charts.product = { columns: custom.product.columns, rows: pick(toRows(custom.product), sizes, false), unit: srcUnit };
    }
    if (custom.body && custom.body.columns) {
      charts.body = { columns: custom.body.columns, rows: pick(toRows(custom.body), sizes, false), unit: srcUnit };
    } else {
      var def = BODY[cfg.category] || WOMEN;
      charts.body = { columns: def.columns, rows: pick(def.rows, sizes, true), unit: 'cm' };
    }
    var st = { cfg: cfg, sizes: sizes, charts: charts, unit: getUnit(), tab: charts.product ? 'product' : 'body' };
    root.querySelector('.sg-tab[data-tab="product"]').hidden = !charts.product;
    var fitKey = String(custom.fit || '').toLowerCase();
    var fitBox = root.querySelector('.sg-fit');
    if (FIT[fitKey] !== undefined) {
      fitBox.hidden = false;
      fitBox.querySelector('.sg-fit-marker').style.left = FIT[fitKey] + '%';
    } else fitBox.hidden = true;
    root.__sg = st;
    return st;
  }

  function selectedSize(root, sizes) {
    var scope = root.closest('.shopify-section') || root.closest('section') || document;
    var els = scope.querySelectorAll('variant-picker input[type="radio"]:checked, variant-picker select, input[type="radio"]:checked');
    var wanted = sizes.map(raw);
    for (var i = 0; i < els.length; i++) {
      var v = raw(els[i].value);
      if (wanted.indexOf(v) > -1) return v;
    }
    return null;
  }

  function render(root) {
    var st = root.__sg || build(root);
    var c = st.charts[st.tab];
    var sel = selectedSize(root, st.sizes);
    var html = '<thead><tr><th>Size</th>' + c.columns.map(function (h) { return '<th>' + esc(h) + '</th>'; }).join('') + '</tr></thead><tbody>';
    c.rows.forEach(function (r) {
      html += '<tr' + (sel && raw(r[0]) === sel ? ' class="is-selected"' : '') + '><td>' + esc(r[0]) + '</td>';
      for (var i = 1; i <= c.columns.length; i++) html += '<td>' + conv(r[i], c.unit, st.unit) + '</td>';
      html += '</tr>';
    });
    root.querySelector('.sg-table').innerHTML = html + '</tbody>';

    root.querySelectorAll('.sg-tab').forEach(function (b) { var on = b.dataset.tab === st.tab; b.classList.toggle('is-active', on); b.setAttribute('aria-selected', on); });
    root.querySelectorAll('.sg-unit').forEach(function (b) { b.classList.toggle('is-active', b.dataset.unit === st.unit); });

    var isBody = st.tab === 'body';
    var bottoms = /_bottoms$/.test(st.cfg.category || '');
    var fig = isBody ? FIG.body : (bottoms ? FIG.pants : FIG.garment);
    var dict = isBody ? BODY_DESC : DESC;
    root.querySelector('.sg-howto-title').textContent = isBody ? 'How to Measure your Body?' : "How to Measure the Product's Size?";
    var items = [];
    c.columns.forEach(function (col) {
      var k = key(col);
      if (!dict[k]) return;
      items.push({ n: fig.map[k], label: String(col).replace(/\s*size$/i, ''), d: dict[k] });
    });
    items.sort(function (a, b) { return (a.n || 99) - (b.n || 99); });
    root.querySelector('.sg-steps').innerHTML = items.map(function (it) {
      return '<li><strong>' + (it.n ? '<span class="sg-num">' + it.n + '</span>' : '') + (isBody ? 'Your ' : '') + esc(it.label) + '</strong><p>' + it.d + '</p></li>';
    }).join('');
    root.querySelector('.sg-figure').innerHTML = fig.svg;
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!(t instanceof Element)) return;
    var trig = t.closest('.sg-trigger');
    if (trig) {
      var root = trig.closest('.sg-root');
      build(root); render(root);
      var dlg = root.querySelector('.sg-dialog');
      if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
      document.documentElement.style.overflow = 'hidden';
      return;
    }
    var r = t.closest('.sg-root');
    if (!r) return;
    var dlg2 = r.querySelector('.sg-dialog');
    if (t.closest('.sg-close') || t === dlg2) { dlg2.close ? dlg2.close() : dlg2.removeAttribute('open'); return; }
    var tab = t.closest('.sg-tab');
    if (tab && r.__sg) { r.__sg.tab = tab.dataset.tab; render(r); return; }
    var unit = t.closest('.sg-unit');
    if (unit && r.__sg) { r.__sg.unit = unit.dataset.unit; setUnit(unit.dataset.unit); render(r); }
  });
  document.addEventListener('close', function (e) {
    if (e.target instanceof Element && e.target.classList.contains('sg-dialog')) document.documentElement.style.overflow = '';
  }, true);
})();
  } catch(e) { console.error(e); }
})();

})();
